<template>
  <div class="flex items-center justify-center gap-16 p-8">
    <!-- 左侧手机（主屏幕） -->
    <div class="iphone-frame">
      <div class="iphone-screen">
        
        <!-- 状态栏 -->
        <div class="status-bar">
          <div>9:41</div>
          <div class="flex items-center gap-3">
            <!-- 信号 -->
            <div class="flex gap-[2px]" style="align-items: flex-end;">
              <div class="w-[3px] h-[4px] bg-black rounded-sm"></div>
              <div class="w-[3px] h-[7px] bg-black rounded-sm"></div>
              <div class="w-[3px] h-[10px] bg-black rounded-sm"></div>
              <div class="w-[3px] h-[13px] bg-black rounded-sm"></div>
            </div>
            <!-- WiFi -->
            <svg width="19" height="14" viewBox="0 0 19 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9.5 11.5C10.3284 11.5 11 10.8284 11 10C11 9.17157 10.3284 8.5 9.5 8.5C8.67157 8.5 8 9.17157 8 10C8 10.8284 8.67157 11.5 9.5 11.5Z" fill="#111"/>
              <path d="M3.5 8.5C3.5 8.5 6 5 9.5 5C13 5 15.5 8.5 15.5 8.5" stroke="#111" stroke-width="1.8" stroke-linecap="round"/>
              <path d="M1 5C1 5 5 1 9.5 1C14 1 18 5 18 5" stroke="#111" stroke-width="1.8" stroke-linecap="round"/>
            </svg>
            <!-- 电池 -->
            <div class="flex items-center gap-px">
              <div class="border border-black rounded-[3px] w-[22px] h-[10px] relative">
                <div class="absolute top-[1px] left-[1px] h-[6px] w-[16px] bg-black rounded-[1px]"></div>
              </div>
              <div class="w-[2px] h-[6px] bg-black rounded-r"></div>
            </div>
          </div>
        </div>
        
        <!-- App 网格 -->
        <div class="px-5 pt-6 grid grid-cols-4 gap-x-6 gap-y-7">
          
          <!-- 第一个带 LOGO 的 App -->
          <div class="flex flex-col items-center">
            <div class="app-icon bg-[#6b7280] text-white">
              <img v-if="icon_src" :src="icon_src" width="44" height="44" />
              <div v-else class="flex flex-col items-center -mt-1" style="padding-top: 10px;">
                <span class="text-[26px] leading-none">?</span>
                <span class="text-[9px] font-medium -mt-1 tracking-wider">LOGO</span>
              </div>
            </div>
            <div class="text-xs font-medium text-black mt-1.5">Logo</div>
          </div>
          
          <!-- 其他空白 App -->
          <div class="flex flex-col items-center">
            <div class="app-icon bg-[#f1f3f5]"></div>
          </div>
          <div class="flex flex-col items-center">
            <div class="app-icon bg-[#f1f3f5]"></div>
          </div>
          <div class="flex flex-col items-center">
            <div class="app-icon bg-[#f1f3f5]"></div>
          </div>
          <div class="flex flex-col items-center">
            <div class="app-icon bg-[#f1f3f5]"></div>
          </div>
          
          <!-- 第2行 -->
          <div class="flex flex-col items-center">
            <div class="app-icon bg-[#f1f3f5]"></div>
          </div>
          <div class="flex flex-col items-center">
            <div class="app-icon bg-[#f1f3f5]"></div>
          </div>
          <div class="flex flex-col items-center">
            <div class="app-icon bg-[#f1f3f5]"></div>
          </div>
          <div class="flex flex-col items-center">
            <div class="app-icon bg-[#f1f3f5]"></div>
          </div>
          
          <!-- 第3行 -->
          <div class="flex flex-col items-center">
            <div class="app-icon bg-[#f1f3f5]"></div>
          </div>
          <div class="flex flex-col items-center">
            <div class="app-icon bg-[#f1f3f5]"></div>
          </div>
          <div class="flex flex-col items-center">
            <div class="app-icon bg-[#f1f3f5]"></div>
          </div>
          <div class="flex flex-col items-center">
            <div class="app-icon bg-[#f1f3f5]"></div>
          </div>
          
          <!-- 第4行 -->
          <div class="flex flex-col items-center">
            <div class="app-icon bg-[#f1f3f5]"></div>
          </div>
          <div class="flex flex-col items-center">
            <div class="app-icon bg-[#f1f3f5]"></div>
          </div>
          <div class="flex flex-col items-center">
            <div class="app-icon bg-[#f1f3f5]"></div>
          </div>
          <div class="flex flex-col items-center">
            <div class="app-icon bg-[#f1f3f5]"></div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- 右侧手机（锁屏/小组件） -->
    <div class="iphone-frame">
      <div class="iphone-screen">
        <!-- 状态栏（同左侧） -->
        <div class="status-bar">
          <div>9:41</div>
          <div class="flex items-center gap-3">
            <!-- 信号 -->
            <div class="flex gap-[2px]" style="align-items: flex-end;">
              <div class="w-[3px] h-[4px] bg-black rounded-sm"></div>
              <div class="w-[3px] h-[7px] bg-black rounded-sm"></div>
              <div class="w-[3px] h-[10px] bg-black rounded-sm"></div>
              <div class="w-[3px] h-[13px] bg-black rounded-sm"></div>
            </div>
            <svg width="19" height="14" viewBox="0 0 19 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9.5 11.5C10.3284 11.5 11 10.8284 11 10C11 9.17157 10.3284 8.5 9.5 8.5C8.67157 8.5 8 9.17157 8 10C8 10.8284 8.67157 11.5 9.5 11.5Z" fill="#111"/>
              <path d="M3.5 8.5C3.5 8.5 6 5 9.5 5C13 5 15.5 8.5 15.5 8.5" stroke="#111" stroke-width="1.8" stroke-linecap="round"/>
              <path d="M1 5C1 5 5 1 9.5 1C14 1 18 5 18 5" stroke="#111" stroke-width="1.8" stroke-linecap="round"/>
            </svg>
            <div class="flex items-center gap-px">
              <div class="border border-black rounded-[3px] w-[22px] h-[10px] relative">
                <div class="absolute top-[1px] left-[1px] h-[6px] w-[16px] bg-black rounded-[1px]"></div>
              </div>
              <div class="w-[2px] h-[6px] bg-black rounded-r"></div>
            </div>
          </div>
        </div>
        
        <!-- 大时间 -->
        <div class="pt-6 text-center">
          <div class="text-[92px] leading-none font-light text-[#d1d5db99] tracking-[-6px]">11:22</div>
        </div>
        
        <!-- 小组件区域 -->
        <div class="px-3 mt-8">
          <!-- 第一行组件 -->
          <div class="bg-zinc-100 rounded-2xl p-4 flex items-center gap-4" style="margin-bottom: 10px;">
              <img v-if="icon_src" :src="icon_src" style="height: 40px;width: 40px;border-radius: 8px;" width="40" height="40" />
              <div v-else class="w-10 h-10  bg-zinc-700 rounded-2xl flex items-center justify-center text-white text-4xl" style="border-radius: 8px;">?</div>
              <div class="flex-1">
                  <div class="h-2.5 bg-white rounded-3xl mb-2.5"></div>
                  <div class="h-2.5 bg-white rounded-3xl w-3/4"></div>
              </div>
          </div>
          
          <!-- 第一行组件 -->
          <div class="bg-zinc-100 rounded-2xl p-4 flex items-center gap-4">
              <div class="flex-1">
                  <div class="h-2.5 bg-white rounded-3xl mb-2.5"></div>
                  <div class="h-2.5 bg-white rounded-3xl w-3/4"></div>
              </div>
          </div>
        </div>
      </div>
    </div>
    
  </div>
</template>
<script>
  export default {
    name:'phone-one',
    props:['icon_src'],
    // data(){
    //   return {
    //     icon_src: "",
    //   }
    // },
  }
</script>


<style scoped>
  .app-icon{
    opacity: 0.8;
  }
  .app-icon.text-white{
    opacity: 1;
  }
  
  .bg-zinc-100{
    background: #d1d5db44;
  }
  body {
    font-family: 'SF Pro Display', system-ui, -apple-system, sans-serif;
  }
  
  .iphone-frame {
    width: 285px;
    height: 617px;
    background: #ffffff;
    border-radius: 30px;
    box-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.4);
    position: relative;
    overflow: hidden;
    border: 2px solid #11111150;
  }
  
  .iphone-screen {
    width: 100%;
    height: 100%;
    background: #FFFFFF;
    padding: 10px 0;
    border-radius: 30px;
    overflow: hidden;
    position: relative;
  }
  
  .status-bar {
    height: 32px;
    padding: 0 22px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    font-weight: 600;
    color: #000000;
    z-index: 20;
  }
  
  .app-icon {
    width: 44px;
    height: 44px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 32px;
  }
</style>